import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createForm } from 'rc-form';
import { Grid, Typography, Button, Fab } from '@material-ui/core';
import AddSharp from '@material-ui/icons/AddSharp';
import SearchIcon from '@material-ui/icons/Search';

import { DEFAULT_ROLE_ORG_ADMIN } from 'yeself-common/defaults/ApplicationDefaults';

import { makeSelectIsRoleIncluded } from 'yeself-client-common/security/SecuritySelector';

import { fetchAdminOrganizationsList } from 'Console/data/organizations/OrganizationsAction';

import { selectAdminOrganizationsList } from 'Console/data/organizations/OrganizationSelector';

import ApplicationList from 'Console/components/applications/ApplicationList';
import DrawerWrapper from 'Console/components/common/drawer/DrawerWrapper';
import CreateNewApplication from 'Console/components/applications/CreateNewApplication';
import Search from 'Console/components/common/search/Search';

import {
    fetchApplicationList,
    setApplicationsSearchTerm,
    createNewApplication,
} from 'Console/data/applications/actions';
import { handleDrawerWrapperToggle } from 'Console/data/app/actions';
import {
    selectFilteredApplicationList,
    selectApplicationSearchTerm,
    selectApplications,
} from 'Console/data/applications/selectors';
import { selectIsDrawerWrapperShown } from 'Console/data/app/selectors';
import { APPLICATION_DETAIL_ROUTE } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: 24,
    },
    search: {
        width: '12rem',
        'margin-bottom': theme.typography.pxToRem(20),
    },
});

class Applications extends Component {
    componentDidMount() {
        const { fetchApplicationList, fetchAdminOrganizationsList } = this.props;
        fetchApplicationList();
        fetchAdminOrganizationsList();
    }

    handleOnChangeList = (e) => {
        const { setApplicationsSearchTerm } = this.props;
        setApplicationsSearchTerm(e.target.value);
    };

    onDetail = (applicationId) => () => {
        const { push } = this.props;
        push(`${APPLICATION_DETAIL_ROUTE}${applicationId}`);
    };

    openDrawerWrapper = () => {
        const { handleDrawerWrapperToggle } = this.props;
        handleDrawerWrapperToggle(true);
    };

    closeDrawerWrapper = () => {
        const {
            handleDrawerWrapperToggle,
            form: { setFieldsValue },
        } = this.props;
        handleDrawerWrapperToggle(false);

        setFieldsValue({
            name: '',
            domain: '',
            inviteEmails: '',
            organizationId: '',
        });
    };

    createApp = () => {
        const {
            form: { getFieldsValue, getFieldError, getFieldsError, setFieldsValue },
            createNewApplication,
            intl,
            organizationsList,
        } = this.props;
        const values = getFieldsValue(['name', 'domain', 'inviteEmails', 'organizationId']);
        const organizationId =
            values.organizationId?.id || organizationsList.length ? organizationsList[0].id : null;
        const newApplication = { ...values, organizationId };
        const errors = [];

        for (const error in getFieldsError()) {
            if (getFieldError(error)) {
                errors.push(getFieldError(error));
            }
        }

        if (errors.length > 0) {
            return;
        }

        createNewApplication(newApplication, {
            success: `${intl.formatMessage({ id: 'Notification.invite.user' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });

        setFieldsValue({
            inviteEmails: [],
        });

        this.closeDrawerWrapper();

        const { fetchApplicationList } = this.props;
        fetchApplicationList();
    };

    render() {
        const {
            classes,
            intl,
            applicationList,
            applicationListHasError,
            applicationListIsLoading,
            searchTerm,
            isDrawerWrapperShown,
            form,
            form: { getFieldsValue },
            isRoleOrganizationAdmin,
            organizationsList,
        } = this.props;

        const values = getFieldsValue(['domain']);

        return (
            <Grid container justify="center" className={classes.root}>
                <DrawerWrapper
                    title={
                        <FormattedMessage id="General.createApplication" defaultMessage="Create space" />
                    }
                    name={<FormattedMessage id="Buttons.cancel" defaultMessage="Cancel" />}
                    term={<FormattedMessage id="Buttons.create" defaultMessage="Create" />}
                    isShown={isDrawerWrapperShown}
                    onClose={this.closeDrawerWrapper}
                    onConfirm={this.createApp}
                    confirmDisabled={!values.domain}
                >
                    <CreateNewApplication form={form} organizations={organizationsList} />
                </DrawerWrapper>
                <Grid item xs={12} md={10}>
                    <Grid
                        style={{ marginBottom: '28px' }}
                        container
                        justify="space-between"
                        alignItems="flex-end"
                    >
                        <Typography variant="h6">
                            <FormattedMessage id="Navigation.applications" defaultMessage="Spaces" />
                        </Typography>

                        {isRoleOrganizationAdmin && (
                            <Grid item>
                                <Typography>
                                    <Button
                                        id="yeself-button"
                                        className="yeself-create-app-button"
                                        variant="contained"
                                        color="primary"
                                        onClick={this.openDrawerWrapper}
                                    >
                                        <AddSharp fontSize='small'/>

                                        <FormattedMessage
                                            id="Buttons.createNewApp"
                                            defaultMessage="Create a space"
                                        />
                                    </Button>
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                    <Grid container justify="flex-start">
                        <Grid item className={classes.search}>
                            <Search
                                id="form-item-search"
                                placeholder={intl.formatMessage({
                                    id: 'General.search.placeholder',
                                })}
                                onChange={this.handleOnChangeList}
                                value={searchTerm}
                            />
                        </Grid>
                        <Fab color="primary" aria-label="Search" style={{ marginLeft: '0.9375rem' }}>
                            <SearchIcon />
                        </Fab>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={10}>
                    <ApplicationList
                        hasError={applicationListHasError}
                        list={applicationList}
                        isLoading={applicationListIsLoading}
                        pushToDetail={this.onDetail}
                    />
                </Grid>
            </Grid>
        );
    }
}
export default withStyles(styles)(
    injectIntl(
        connect(
            (state) => {
                const selectUserRole = makeSelectIsRoleIncluded();
                return {
                    applicationList: selectFilteredApplicationList(state),
                    applicationListHasError: state.applications.list.hasError,
                    applicationListIsLoading: state.applications.list.isLoading,
                    searchTerm: selectApplicationSearchTerm(state),
                    isDrawerWrapperShown: selectIsDrawerWrapperShown(state),
                    applicationListData: selectApplications(state),
                    isRoleOrganizationAdmin: selectUserRole(state, {
                        includedRole: DEFAULT_ROLE_ORG_ADMIN,
                    }),
                    organizationsList: selectAdminOrganizationsList(state),
                };
            },
            {
                fetchApplicationList,
                push,
                setApplicationsSearchTerm,
                handleDrawerWrapperToggle,
                createNewApplication,
                fetchAdminOrganizationsList,
            }
        )(createForm()(Applications))
    )
);
